/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "service": {
            "nested": {
              "GetAccountTransferEligibilityResponse": {
                "nested": {
                  "TransferIneligibleReason": {
                    "values": {
                      "TIR_DO_NOT_USE": 0,
                      "SAVINGS_ACTIVE": 1
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.service?.nested?.GetAccountTransferEligibilityResponse?.nested?.TransferIneligibleReason) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetAccountTransferEligibilityResponse @ squareup/sfs/services/customer/get_account_transfer_eligibility.proto at 19:1
 */
export const GetAccountTransferEligibilityResponse = {};
/**
 * SOURCE TransferIneligibleReason @ squareup/sfs/services/customer/get_account_transfer_eligibility.proto at 20:3
 */
GetAccountTransferEligibilityResponse.TransferIneligibleReason = $root.lookupEnum('squareup.sfs.service.GetAccountTransferEligibilityResponse.TransferIneligibleReason').values;